import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const businessHrsApi = createApi({
    reducerPath: 'businessHrsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        credentials: 'include'
    }),
    endpoints: (builder) => ({
        getBusinessHours: builder.mutation({
            query: () => ({
                url: 'company/business-hours',
                method: 'GET'
            })
        }),
        updateBusinessHours: builder.mutation({
            query: (payload) => ({
                url: 'company/business-hours',
                method: 'PUT',
                body: payload
            })
        })
    })
})

export const { useGetBusinessHoursMutation, useUpdateBusinessHoursMutation } = businessHrsApi;